/**
 * Catalogo piste del prototipo. Ponte verso lo Sprint 1 (grammatica a sezioni +
 * validatore): per ora ogni pista è (seed, difficoltà) e il generatore value-noise
 * la costruisce. Dà varietà SUBITO e introduce il concetto di "pista di oggi".
 */

import type { I18nKey } from './i18n';
import { dailySeed } from './daily';

export type TrackKind = 'daily' | 'preset' | 'random';

export interface TrackDef {
  id: string;
  nameKey: I18nKey;
  seed: string;
  difficulty: number; // 0..1 (vedi makeTerrain)
  kind: TrackKind;
}

export function dailyTrack(): TrackDef {
  return { id: 'daily', nameKey: 'track.daily', seed: dailySeed(), difficulty: 0.5, kind: 'daily' };
}

export const PRESETS: readonly TrackDef[] = [
  { id: 'warmup', nameKey: 'track.warmup', seed: 'wake-onde', difficulty: 0.28, kind: 'preset' },
  { id: 'classic', nameKey: 'track.classic', seed: 'wake-colline', difficulty: 0.52, kind: 'preset' },
  { id: 'steep', nameKey: 'track.steep', seed: 'wake-cresta', difficulty: 0.82, kind: 'preset' },
];

export function randomTrack(): TrackDef {
  // Math.random qui è OK: sceglie il seed, non gira dentro la sim.
  const seed = 'wake-rnd-' + Math.random().toString(36).slice(2, 9);
  return { id: 'random', nameKey: 'track.random', seed, difficulty: 0.5, kind: 'random' };
}

/** Pallini di difficoltà per la UI: ●○○ .. ●●●. */
export function difficultyDots(d: number): string {
  const n = d < 0.38 ? 1 : d < 0.62 ? 2 : 3;
  return '●'.repeat(n) + '○'.repeat(3 - n);
}
